import { useCallback } from 'react';

export const useNameValidation = () => {
  const validateName = useCallback(
    (t, nameUntrimmed: string, fieldName, callBack, min?: number, max?: number) => {
      let returnValue = '';
      const name = nameUntrimmed?.trim();
      if (!name) {
        returnValue = t('common.form.validation.required', { fieldName });
      } else {
        if (name.length < min && name.length !== min) {
          returnValue = t('common.form.validation.minlength', {
            fieldName,
            minLength: min,
          });
        } else if (name.length > max && name.length !== max) {
          returnValue = t('common.form.validation.maxlength', {
            fieldName,
            maxLength: max,
          });
        }
      }
      callBack(returnValue);
      return returnValue;
    },
    [],
  );

  return { validateName };
};

export const validateNumber = (
  t,
  number: number,
  fieldName: string,
  min?: number,
  max?: number,
) => {
  if (number === null || number === undefined) {
    return t('common.form.validation.required', {
      fieldName,
    });
  } else {
    if (min && number < min) {
      return t('common.form.validation.minnum', {
        fieldName,
        minLength: min,
      });
    } else if (max && number > max) {
      return t('common.form.validation.maxnum', {
        fieldName,
        maxLength: max,
      });
    }
  }
  return '';
};
